import React, { useState, useEffect } from 'react';
import './index.less';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import Button, { promisifyValidate } from '@/components/Button';
import { Icon, Timeline, Tag, Modal, Input, Form, Message } from '@b-design/fusion';
import { formatTime } from '@/utils';
import { getQueryStringArgs } from '@/utils/url-parse';
import QRCode from '@/components/QRCode';
import { Field } from '@alifd/next';
// import NameIcon from '@/components/NameIcon';
import Confirm from '@/components/Confirm';
import DefaultAppIcon from '@/components/DefaultAppIcon';
import CalculateComponent from '@/components/CalculateComponent';
interface App {
  versionDetail: any;
  initDataSource: any;
  roleList: any;
}
const App: React.FC<App> = ({ versionDetail, initDataSource, roleList }) => {
  const [contentHeight, setContentHeight] = useState(200);
  const field = Field.useField();
  const { init, getValue, setValue, getError } = field;
  const { approveId } = getQueryStringArgs();
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const renderPhone = (v) => {
    let text = '';
    if (v !== '-') {
      if (v?.split('-')[0]) {
        text = `+${v?.split('-')[0]} ${v?.split('-')[1]}`;
      } else {
        text = `${v?.split('-')[1]}`;
      }
    } else {
      text = '';
    }
    return text;
  };

  // 通过按钮
  const handleOk = async () => {
    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'PASSED',
      approveOpinion: 'PASSED',
    });
    if (data) {
      initDataSource();
    }
  };
  // 拒绝按钮
  const handleRejectOk = async () => {
    const [errs, vals] = await promisifyValidate(field);
    if (errs) {
      return;
    }

    const data = await Requests.post('/rest/intercnn/approve/process', {
      approveId,
      approveAction: 'REJECT',
      approveOpinion: getValue('description'),
    });
    if (data) {
      setIsRejectModalVisible(false);
      initDataSource();
    }
  };

  const downloadApp = (appId, version) => {
    setDownloadLoading(true);
    Requests.get('/rest/intercnn/app/version/download', {
      appId,
      version,
    })
      .then((data) => {
        setDownloadLoading(false);
        if (!data?.downloadUrl) {
          Message.error({
            title: $i18n.get({ id: 'aopf.detail.app.DownloadFailed', dm: '下载失败' }),
          });
          return;
        }
        window.open(data.downloadUrl);
      })
      .catch(() => setDownloadLoading(false));
  };

  return (
    <>
      <div className="approvals-container">
        <div className="container-left">
          <div className="container-processTitle">
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.process.Approvals.Process',
              dm: '审批流程',
            })}
          </div>
          <Timeline>
            <Timeline.Item
              title={
                <div className="progress-item">
                  <span>{versionDetail?.createName}</span>
                  <span>{formatTime(versionDetail?.gmtCreate)}</span>
                </div>
              }
              content={
                <div className="progress-content">
                  <div className="progress-dec">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.Submit.Release.Application',
                      dm: '提交应用程序版本',
                    })}
                  </div>
                  <Tag data-square>
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.Application',
                      dm: '申请',
                    })}
                  </Tag>
                  <span className="progress-content-text">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.version.info.process.Additional.Information',
                      dm: '申请发布新版本',
                    })}
                  </span>
                </div>
              }
            />
            {versionDetail?.status !== 'PROCESSING' ? (
              <Timeline.Item
                title={
                  <div className="progress-item">
                    <span>{versionDetail?.modifiedName}</span>
                    <span>{formatTime(versionDetail?.gmtModified)}</span>
                  </div>
                }
                content={
                  <div className="progress-content">
                    {versionDetail?.approveAction === 'PASSED' ? (
                      <div>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Review.Application',
                            dm: '审查申请',
                          })}
                        </div>
                        <Tag data-square data-tag-color="cold-green">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Passed',
                            dm: '通过',
                          })}
                        </Tag>
                      </div>
                    ) : versionDetail?.approveAction === 'WITHDRAW' ? (
                      <>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Review.WithDraw',
                            dm: '撤回发布',
                          })}
                        </div>
                        <Tag data-square color="#FFF4ED" style={{ color: '#FF7E33' }}>
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Withdraw',
                            dm: '撤销',
                          })}
                        </Tag>
                        {/* <span className="progress-content-text">{versionDetail?.approveOpinion}</span> */}
                      </>
                    ) : (
                      <>
                        <div className="progress-dec">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Review.Application',
                            dm: '审查申请',
                          })}
                        </div>
                        <Tag data-square data-tag-color="red">
                          {$i18n.get({
                            id: 'aopf.pages.miniapp.version.info.process.Refused',
                            dm: '拒绝',
                          })}
                        </Tag>
                        <span className="progress-content-text">
                          {versionDetail?.approveOpinion
                            ? versionDetail?.approveOpinion
                            : $i18n.get({
                              id: 'aopf.pages.miniapp.version.info.process.No.Reason',
                              dm: '拒绝',
                            })}
                        </span>
                      </>
                    )}
                  </div>
                }
              />
            ) : (
              <></>
            )}
          </Timeline>
          {versionDetail?.status === 'PROCESSING' && roleList?.includes('ADMIN') && (
            <div className="progress-withdraw">
              <Confirm
                trigger={
                  <Button type="primary" style={{ marginRight: '16px' }}>
                    {$i18n.get({
                      id: 'aopf.approvals.datail.approve',
                      dm: '批准',
                    })}
                  </Button>
                }
                dialogTitle={$i18n.get({
                  id: 'aopf.pages.approvals.version.info.process.approved',
                  dm: '审批详情',
                })}
                dialogContent={$i18n.get({
                  id: 'aopf.pages.approvals.detail.agreeContent.version',
                  dm: '你正在处理发布申请,是否批准',
                })}
                onClick={handleOk}
              />
              <Button type="secondary" onClick={() => setIsRejectModalVisible(true)} style={{ marginRight: '16px' }}>
                {$i18n.get({
                  id: 'aopf.approvals.datail.reject',
                  dm: '拒绝',
                })}
              </Button>
              {/* 审核中 展示下载app按钮 */}
              <Button
                type="secondary"
                loading={downloadLoading}
                onClick={() =>
                  downloadApp(
                    versionDetail?.extInfo?.version?.appId,
                    versionDetail?.extInfo?.version?.version,
                  )
                }
              >
                {$i18n.get({ id: 'aopf.detail.app.Download', dm: '下载' })}
              </Button>
            </div>
          )}
        </div>

        <div className="container-right" style={{ position: 'relative' }}>
          {versionDetail?.extInfo?.description?.iconPublicUrl ? (
            <img className="logo" src={versionDetail?.extInfo?.description?.iconPublicUrl} />
          ) : (
            <DefaultAppIcon className="logo" />
          )}
          <div style={{ position: 'absolute', top: '24px', right: '32px' }}>
            <QRCode url={versionDetail?.extInfo?.version?.previewUrl} />
          </div>
          <div className="right-appInfo">
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.App.information',
              dm: '应用程序信息',
            })}
          </div>
          <div className="right-content">
            <div className="right-icon">
              <Icon type="mobile--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Miniapp.Name',
                dm: 'Miniapp名称',
              })}
            </div>
            <div className="left-context">{versionDetail?.extInfo?.description?.name}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="apps--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Type',
                dm: '类型',
              })}
            </div>
            <div className="left-context">{versionDetail?.extInfo?.app?.framework}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="user--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.process.Creator',
                dm: '作者',
              })}
            </div>
            <div className="left-context">{versionDetail?.extInfo?.description?.createName}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="wikis--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Slogan',
                dm: '标语',
              })}
            </div>
            <div className="left-context">{versionDetail?.extInfo?.description?.slogan}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="document--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Description',
                dm: '描述',
              })}
            </div>
            <div className="left-context">{versionDetail?.extInfo?.description?.description}</div>
          </div>

          <div className="right-appInfo">
            {$i18n.get({
              id: 'aopf.pages.miniapp.version.info.Version.information',
              dm: '版本信息',
            })}
          </div>
          <div className="right-content">
            <div className="right-icon">
              <Icon type="package--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Version',
                dm: '版本',
              })}
            </div>
            <div className="left-context">v{versionDetail?.extInfo?.description?.version}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="equipment--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.process.Channel',
                dm: '渠道',
              })}
            </div>
            <div className="left-context">{versionDetail?.extInfo?.version?.channelName}</div>
          </div>

          <div className="right-content">
            <div className="right-icon">
              <Icon type="folder--details--outline" size="xs" />
            </div>
            <div className="right-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Release.Note',
                dm: '发布说明',
              })}
            </div>
            <div className="left-context">{versionDetail?.extInfo?.version?.changelog}</div>
          </div>
          {/* <div style={{ marginTop: '16px', marginLeft: '-11px' }} >
             <QRCode url={versionDetail?.extInfo?.version?.previewUrl} />
            </div> */}
        </div>
        <Modal
          title={$i18n.get({
            id: 'aopf.pages.approvals.version.info.process.reject',
            dm: '拒绝申请',
          })}
          // data-size="xs"
          visible={isRejectModalVisible}
          // onOk={handleRejectOk}
          onCancel={() => setIsRejectModalVisible(false)}
          closeMode={['close', 'esc', 'mask']}
          onClose={() => setIsRejectModalVisible(false)}
          footer={
            <div>
              <Button onClick={() => setIsRejectModalVisible(false)}>
                {$i18n.get({
                  id: 'aopf.pages.approvals.version.info.confirm.Cancel',
                  dm: '取消',
                })}
              </Button>
              <Button type="primary" onClick={handleRejectOk} style={{ marginLeft: '8px' }}>
                {$i18n.get({
                  id: 'aopf.pages.approvals.version.info.confirm.Ok',
                  dm: '确定',
                })}
              </Button>
            </div>
          }
        >
          <div
            style={{
              marginTop: '20px',
              width: '500px',
              fontSize: '14px',
              letterSpacing: '0.47px',
              lineHeight: '20px',
              fontWeight: '400',
            }}
          >
            <Form>
              <Form.Item
                name="description"
                label={$i18n.get({ id: 'aopf.pages.approvals.form.title.description', dm: '描述' })}
              >
                <Input.TextArea
                  placeholder={$i18n.get({
                    id: 'aopf.pages.approvals.form.Description.placeholder',
                    dm: '输入2-200个字符的描述',
                  })}
                  autoHeight={{ minRows: 4, maxRows: 8 }}
                  style={{ width: '470px' }}
                  {...init('description', {
                    initValue: '',
                    rules: {
                      required: true,
                      minLength: 2,
                      maxLength: 200,
                      message: $i18n.get({
                        id: 'aopf.pages.approvals.form.Description.placeholder',
                        dm: '输入2-200个字符的描述',
                      }),
                    },
                  })}
                  showLimitHint
                  maxLength={200}
                />
                <p style={{ fontSize: 12, color: '#c82727' }}>{getError('description')}</p>
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
      <CalculateComponent
        otherWidth={280}
        otherHeight={0}
        windowChange={(_width, height) => {
          setContentHeight(height);
        }}
      />
    </>
  );
};
export default App;
